
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import './App.css';
import { store } from './Redux/stores/store';
import Router from './Route/Router';
import { useEffect } from 'react';
import { ConfigProvider } from 'antd';
// import runOneSignal from './Utils/onesignal';
// import OneSignalReact from 'react-onesignal';
import { apiCall } from './API/RestApi';
import ServerConnectionChecker from './Utils/Connection/ServerConnectionChecker';

const App = () => {
  // const count = useRef(null);
  useEffect(() => {
    cekToken();
    // if (count.current == null) {
    //   runOneSignal();
    // }
    // getDataNotif();
    // return () => { count.current = 1; }
  }, []);

  function cekToken() {
    const dataReq = {
      method: "GET",
      url: '/checktoken',
    };
    apiCall(dataReq).then((res) => {
      if (res.statusAvailable === false) {
        const dataReq = {
          method: "PUT",
          url: '/token',
        };
        apiCall(dataReq).then((res2) => {
          console.log(res2)
        });
      }
    })
  }

  // function getDataNotif() {
  //   OneSignalReact.addListenerForNotificationOpened().then((res) => console.log(res)).catch((e) => console.log(e));
  // }
  return (
    <>
      <HelmetProvider>
        <Provider store={store}>
          <ConfigProvider
            virtual={false}
            theme={{
              token: {
                colorPrimary: '#c21867',
                colorInfo: '#c21867',
                colorLink: '#c21867',
                borderRadius: 10,
                borderRadiusLG: 14,
                controlHeight: 40,
                fontSize: 14,
                colorBgLayout: '#f7f8fc',
                colorBorder: '#e8eaf0',
              },
              components: {
                Button: { primaryShadow: '0 6px 16px rgba(194, 24, 103, 0.18)' },
                Card: { headerBg: '#ffffff' },
                Table: { headerBg: '#faf7f9', headerColor: '#4b4450' },
                Menu: { itemBorderRadius: 10, itemMarginInline: 8 },
                Select: {
                  optionHeight: 36,
                  optionPadding: '8px 10px',
                  optionSelectedBg: '#fff1f7',
                  optionActiveBg: '#faf0f5',
                  multipleItemHeight: 28,
                },
              },
            }}
          >
            <ServerConnectionChecker />
            <Router />
          </ConfigProvider>
        </Provider>
      </HelmetProvider>
    </>
  );
}

export default App;
